import cytoscape from 'cytoscape'
import dagre from 'cytoscape-dagre'

// NOTE: unfortunately, the types for cytoscape-dagre use their own version of
// cytoscape, which causes type issues here
cytoscape.use(dagre as unknown as cytoscape.Ext)

export const LAYOUT_OPTIONS = {
  animate: true,
  animationDuration: 300,
  edgeSep: 10,
  name: 'dagre',
  nodeSep: 30,
  padding: 50,
  rankDir: 'TB',
  rankSep: 30,
  ranker: 'network-simplex',
  // Sort siblings by their original data order (siblingOrder)
  // This prevents nodes from switching places when expanding/collapsing
  sort: (
    a: { data: (key: string) => number },
    b: { data: (key: string) => number },
  ) => (a.data('siblingOrder') ?? 0) - (b.data('siblingOrder') ?? 0),
  spacingFactor: 1.1,
} as cytoscape.LayoutOptions
